import Vue from 'vue'
import App from './App.vue'
import router from './router/index.js'
import store from './store'
import './plugins/element.js'
import '@/assets/css/index.css'
import '@/assets/js/index.js'
// import echarts from 'echarts'
import VueCookies from "vue-cookies";
import 'webui-popover/dist/jquery.webui-popover.min.js';
import 'webui-popover/dist/jquery.webui-popover.min.css';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import '@/assets/js/viewer.js'
import '@/assets/css/viewer.css'
// import VideoPlayer from 'vue-video-player'
// import 'video.js/dist/video-js.css'
// import 'vue-video-player/src/custom-theme.css'

// import 'normalize.css'

Vue.config.productionTip = false
Vue.use(VueCookies);
Vue.use(VueAwesomeSwiper);
// Vue.use(VideoPlayer)
// Vue.use(echarts);

Vue.prototype.$isSubLib = false


new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')


